import { $root } from './model'

// Protobuf message models
// export const Response = $root['Response']
export const ResponseBatch = $root['ResponseBatch']
// export const Request = $root['Request']
export const RequestBatch = $root['RequestBatch']
// export const IncomingMessagesRequest = $root['In/comingMessagesRequest']
export const IncomingMessage = $root['IncomingMessage']
export const Receiver = $root['Receiver']
